import {Notification} from 'element-ui'

/**
 * @date 2019/04/17
 * @author crq131290
 * @param {Number} state 状态码
 * @param {String} msg 提示信息
 * 200 成功
 * 400 请求错误
 * 401 冲突
 * 404 地址错误
 * 500 服务器错误
 * 
 */
export const data = {
  200:{
    type:'success',
    title:'success',
    message:'成功'
  },
  400:{
    type:'error',
    title:'error',
    message:'失败'
  },
  401:{
    type:'error',
    title:'error',
    message:'未登录'
  },
  403:{
    type:'error',
    title:'error',
    message:'无权限'
  },
  409:{
    type:'warning',
    title:'warning',
    message:'冲突',
  },
  404:{
    type:'error',
    title:'error',
    message:'资源不存在',
  },
  407:{
    type:'warning',
    title:'warning',
    message:'暂无数据',
  },
  500:{
    type:'error',
    title:'error',
    message:'服务器错误',
  },
  504:{
    type:'error',
    title:'error',
    message:'服务器找不到了',
  }
}
export function msgNotify(state,msg){
  let config = data[state] || {
    type:'error',
    title:'失败',
    message:'未知错误',
    duration:2000
  }
  Notification({
    type:config.type,
    title:config.title,
    message:msg||config.message,
    duration:2000
  })
  
}


// WEBPACK FOOTER //
// ./src/common/js/notify.js